export enum MessageEntityType {
  ANSWER = 'answer',
  DOCUMENT = 'document',
  SECTION = 'section',
}

export type ThreadType = `${MessageEntityType}`;

type MessageAction =
  | 'Answer Updated'
  | 'Message sent to QC Team'
  | 'Responded to request'
  | 'Document Uploaded';

export type Thread = {
  id?: string;
  entityId: string;
  entityType: ThreadType;
  typeOfThread?: 'questionMessage' | 'documentMessage' | 'documentRequest';
  isResolved?: boolean;
  /** Determines if a thread is closed and no longer accepting messages */
  isClosed?: boolean;
  /** The date the thread was updated, often used when the thread is closed */
  updatedDt?: string;
  lastUpdated?: string;
  workspaceId: string;
  messages?: ThreadMessage[];
  data?: {
    action?: MessageAction;
    documentTypeName?: string;
    documentTypeId?: string;
    title?: string; // file name from socket, not API
    resolvingDocumentId?: string; // ID of document that resolved if present
  };
};

export interface ThreadMessage {
  id: string;
  text: string;
  sender: IMessageUser;
  createdDt: string;
  updatedDt: string;
  data: {
    action?: MessageAction;
    documentTypeName?: string;
    documentTypeId?: string;
    resolvingDocumentId?: string;
  };
}

export type IMessageUser = {
  id: string;
  email?: string;
  firstName: string;
  lastName: string;
  isInternal: boolean;
};

export type QuestionMessages = {
  id: string;
  workspaceId: string;
  entityId: string;
  entityType: ThreadType;
  isResolved: boolean;
};

export type IMessageResults = {
  data: ThreadMessage[];
  total: number;
};

/* eslint-disable @typescript-eslint/naming-convention */
export interface IMessageReqBody {
  data?: {
    action: string;
  };
  entity_id: string;
  entity_type: string;
  text: string;
  workspace_id: string;
  response_required?: boolean;
}

export interface IMessageResponse {
  id: string;
  text: string;
  workspace_id: string | null;
  parent_id: string | null;
  entity_id: string;
  entity_type: ThreadType;
  is_resolved: boolean | null;
  data: unknown;
  sender: Partial<IUser>;
  created_dt: string;
  updated_dt: string;
  sent_timestamp: string;
  resolved_by_id: string | null;
  resolved_by: IUser | null;
  respond: string | null;
  draft_timestamp: string | null;
}

type IUser = {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
};
/* eslint-disable @typescript-eslint/naming-convention */
